import { ProfileActionType } from '../actions/profile';
import { AuthActionTypes } from '../actions/auth';

const initialState = {
  user: {
    firstName: '',
    lastName: '',
  },
};

export default function profile(state: any = initialState, action: any) {
  switch (action.type) {
    case ProfileActionType.UPDATE_PROFILE:
      return { ...state, user: action.payload };
    // Login/logout is SPA navigation, so without this the previous user's profile
    // stays in the store until the next user's fetch resolves
    case AuthActionTypes.LOGOUT:
      return initialState;
  }
  return state;
}
